import styled from '@emotion/styled'
import { isMobile } from '@const/device'
import WhiteButton from '@organisms/WhiteButton'

export const ScormFinalTestModalFrame = styled.div`
  .scorm-final-test-modal {
    width: min(912px, calc(100vw - 90px));
    max-width: min(912px, calc(100vw - 90px));
    min-width: 0;
    box-sizing: border-box;
  }

  .scorm-final-test-modal h1,
  .scorm-final-test-modal h2 {
    margin: 0;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: 0;
    white-space: normal;
  }

  .scorm-final-test-modal #contentFields > div > div {
    gap: 18px;
  }

  .scorm-final-test-modal #contentFields label {
    padding-top: 0;
  }

  .scorm-final-test-modal #contentFields label > div:first-of-type {
    height: 30px;
    white-space: nowrap;
  }

  .scorm-final-test-modal #contentFields input {
    height: 40px;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 20px;
  }

  .scorm-final-test-modal #scorm-final-test-file button {
    width: 260px;
    min-width: 260px;
    height: 40px;
    justify-content: center;
    border-radius: 30px;
    background: #1d4e89;
    color: #fff;
  }

  .scorm-final-test-modal #scorm-final-test-file button > span,
  .scorm-final-test-modal #scorm-final-test-file button > span + span {
    justify-content: center;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  @media (max-width: 900px) {
    .scorm-final-test-modal {
      width: min(100%, calc(100vw - 34px));
      max-width: calc(100vw - 34px);
    }

    .scorm-final-test-modal #contentFields > div > div {
      flex-direction: column;
      gap: 12px;
    }

    .scorm-final-test-modal #contentFields label {
      width: 100%;
    }

    .scorm-final-test-modal #contentFields label > div:first-of-type {
      height: auto;
      white-space: normal;
    }

    .scorm-final-test-modal #scorm-final-test-file button {
      width: 100%;
      min-width: 0;
    }
  }
`

export const InstructionBlock = styled.div`
  background: #eef2f8;
  border-radius: 22px;
  padding: 20px 16px 16px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 913px;
  box-sizing: border-box;
`

export const InstructionList = styled.ul`
  margin: 0;
  padding: 0 0 0 23px;
  font-size: 14px;
  line-height: 1.65;
  color: #000;

  li {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const CodeSnippet = styled.pre`
  margin: 0;
  padding: 31px 48px;
  background: #e8eff8;
  border: none;
  width: ${isMobile ? '100%' : '412px'};
  max-width: 100%;
  min-height: 270px;
  color: #000;
  font-family: 'SFMono-Regular', 'Consolas', 'Courier New', Courier, monospace;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.06em;
  border-radius: 12px;
  white-space: pre-wrap;
  font-weight: 500;
  box-sizing: border-box;
  align-self: flex-start;
  overflow-x: auto;
`

export const SnippetButtons = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

export const SnippetActionButton = styled(WhiteButton)`
  color: #000;
  border: 1px solid #1d4e89;
  background: #fff;
  text-transform: none;
  justify-content: center;

  &:hover,
  &:active,
  &:focus-visible {
    color: #000;
    border-color: #1d4e89;
    background: #fff;
  }
`
